/** Сумма со знаком для показа: минус — типографский («−1235.00»), чтобы его нельзя было принять
 * за дефис; положительные суммы — без знака. */
export function displaySigned(amount: string): string {
  return amount.startsWith('-') ? `−${amount.slice(1)}` : amount;
}
